<template>
	<div class="componentSty">
		<m-title :titlelist="listitem"></m-title>
		<div class="componentSty_content">
			<div class="componentSty_content_title">
				<span style="color: #076E60;font-size: 20px;">
					【与生产系统接口对接数据查询及手动更新操作】
				</span>
			</div>
			<div class="componentSty_content_table" style="border:none">
				<!--计划数据更新查询-->
				<div class="componentSty_content_title">
					<span class="fonints">计划单号</span>
					<el-input placeholder="请输入关键词" v-model="jhgx_jihuadanhao" clearable>
					</el-input>
				
					<button class="buttons" @click="getjhgxarrlist">查询</button>
					<button class="buttons" @click="updatePlanInfoByPno" style="background-color: #f56c6c;">手动更新</button>
					<span style="color: #606266;font-size: 14px;">
						【根据计划号获取计划详情】
					</span>
				</div>
				<el-table :data="jhgx_arr" border height="30%"
					style="width: 100%; height: 80%;border-bottom: 2px solid #17B6A1;">
					<el-table-column show-overflow-tooltip :render-header="renderHeader" label="序号" type="index" width="50px"></el-table-column>
					<el-table-column show-overflow-tooltip :render-header="renderHeader" prop="daoyunguanlianjihua" label="港内集疏关联计划号"> </el-table-column>
					<el-table-column show-overflow-tooltip :render-header="renderHeader" prop="cargoagencyname" label="代理"> </el-table-column>
					<el-table-column show-overflow-tooltip :render-header="renderHeader" prop="cargoname" label="货类"> </el-table-column>
					<el-table-column show-overflow-tooltip :render-header="renderHeader" prop="cargoagencyname" label="货代"> </el-table-column>
					<el-table-column show-overflow-tooltip :render-header="renderHeader" prop="lurushijian" label="创建时间"> </el-table-column>
					<el-table-column show-overflow-tooltip :render-header="renderHeader" prop="begindate" label="计划开始时间"> </el-table-column>
					<el-table-column show-overflow-tooltip :render-header="renderHeader" prop="plantonnage" label="计划吨数"> </el-table-column>
					<el-table-column show-overflow-tooltip :render-header="renderHeader" prop="shipname" label="船名"> </el-table-column>
					<el-table-column show-overflow-tooltip :render-header="renderHeader" prop="blno" label="提单号"> </el-table-column>
					<el-table-column show-overflow-tooltip :render-header="renderHeader" prop="tbf" label="磅房"> </el-table-column>
					<el-table-column show-overflow-tooltip :render-header="renderHeader" prop="zhuangtai" label="计划状态(正常0停用2删除1完工3暂停4)">
					</el-table-column>
				</el-table>

				<!--磅单数据更新查询-->
				<div class="componentSty_content_title">
					<span class="fonints">计划单号</span>
					<el-input placeholder="请输入关键词" v-model="zt_jihuahao" clearable>
					</el-input>
					<span class="fonints">车牌号</span>
					<el-input placeholder="请输入关键词" v-model="zt_chepaihao" clearable>
					</el-input>
					<button class="buttons" @click="getLastWeightByPlateNumber">查询车辆磅单</button>
					<button class="buttons" style="background-color: #67c23a;" @click="getCarLastState">查询车辆状态</button>
					<button class="buttons" style="background-color: #409eff;" @click="getWeightList">查询计划磅单</button>
					<button class="buttons" @click="updateBangDan" style="background-color: #f56c6c;">手动更新磅单</button>
					<span style="color: #606266;font-size: 14px;">
						【根据计划号或车牌号获取磅单数据】
					</span>
				</div>

				<el-table :data="arrWeightList" border height="40%"
					style="width: 100%; height: 80%;border-bottom: 2px solid #17B6A1;">
					<el-table-column show-overflow-tooltip :render-header="renderHeader" label="序号" type="index" width="50px"></el-table-column>
					<el-table-column show-overflow-tooltip :render-header="renderHeader" prop="paigongguanlianid" label="派车号"> </el-table-column>
					<el-table-column show-overflow-tooltip :render-header="renderHeader" prop="jihuahao" label="计划号"> </el-table-column>
					<el-table-column show-overflow-tooltip :render-header="renderHeader" prop="chepai" label="车牌号"> </el-table-column>
					<el-table-column show-overflow-tooltip :render-header="renderHeader" prop="maozhong" label="毛重"> </el-table-column>
					<el-table-column show-overflow-tooltip :render-header="renderHeader" prop="pizhong" label="皮重"> </el-table-column>
					<el-table-column show-overflow-tooltip :render-header="renderHeader" prop="jingzhong" label="净重"> </el-table-column>
					<el-table-column show-overflow-tooltip :render-header="renderHeader" prop="maozhongshijian" label="毛重时间"> </el-table-column>
					<el-table-column show-overflow-tooltip :render-header="renderHeader" prop="pizhongshijian" label="皮重时间"> </el-table-column>
					<el-table-column show-overflow-tooltip :render-header="renderHeader" prop="jingzhongshijian" label="净重时间"> </el-table-column>
					<el-table-column show-overflow-tooltip :render-header="renderHeader" prop="huoming" label="货类"> </el-table-column>
					<el-table-column show-overflow-tooltip :render-header="renderHeader" prop="huochang" label="货场"> </el-table-column>
					<el-table-column show-overflow-tooltip :render-header="renderHeader" prop="chuanming" label="船名"> </el-table-column>
					
				</el-table>

				<!--根据计划号获取车队派工数据-->
				<div class="componentSty_content_title">
					<span class="fonints">计划单号</span>
					<el-input placeholder="请输入关键词" v-model="pc_jihuahao" clearable>
					</el-input>
					<button class="buttons" @click="getFleetDispatch">查询车队派工</button>
					<button class="buttons" @click="updateFleetDispatch"
						style="background-color: #f56c6c;">手动更新车队派工数据</button>
					<span style="color: #606266;font-size: 14px;">
						【根据计划号获取车队派工数据】
					</span>
				</div>
				<el-table :data="arrFleetList" border height="40%"
					style="width: 100%; height: 80%;border-bottom: 2px solid #17B6A1;">
					<el-table-column show-overflow-tooltip :render-header="renderHeader" label="序号" type="index" width="50px"></el-table-column>
					<el-table-column show-overflow-tooltip :render-header="renderHeader" prop="guobangjihuaid" label="计划号"> </el-table-column>
					<el-table-column show-overflow-tooltip :render-header="renderHeader" prop="cheduimingcheng" label="车队名称"> </el-table-column>
					<el-table-column show-overflow-tooltip :render-header="renderHeader" prop="xupaicheshuliang" label="需派车数量"> </el-table-column>
					<el-table-column show-overflow-tooltip :render-header="renderHeader" prop="lurushijian" label="派车时间"> </el-table-column>
					<el-table-column show-overflow-tooltip :render-header="renderHeader" prop="lururen" label="派车人"> </el-table-column>
					<el-table-column show-overflow-tooltip :render-header="renderHeader" prop="shenhezhuangtai" label="审核状态(0待审核;1审核通过;2审核通过)">
					</el-table-column>
				</el-table>


				<!--根据车队编号获取车辆列表-->
				<div class="componentSty_content_title">
					<span class="fonints">车队名称</span>
					<el-input placeholder="请输入关键词" v-model="fleetname" clearable>
					</el-input>
					<button class="buttons" @click="getCarListByFleet">查询车辆数据</button>
					<button class="buttons" @click="updateCarListByFleet"
						style="background-color: #f56c6c;">手动更新车辆数据</button>
					<span style="color: #606266;font-size: 14px;">
						【根据车队名称获取车辆数据】
					</span>
				</div>
				<el-table :data="arrCarList" border height="40%"
					style="width: 100%; height: 80%;border-bottom: 2px solid #17B6A1;">
					<el-table-column show-overflow-tooltip :render-header="renderHeader" label="序号" type="index" width="50px"></el-table-column>
					<el-table-column show-overflow-tooltip :render-header="renderHeader" prop="chepaihao" label="车牌号"> </el-table-column>
					<el-table-column show-overflow-tooltip :render-header="renderHeader" prop="cheduimingcheng" label="车队名称"> </el-table-column>
					<el-table-column show-overflow-tooltip :render-header="renderHeader" prop="haiguanjianguan" label="海关监管"> </el-table-column>
					<el-table-column show-overflow-tooltip :render-header="renderHeader" prop="fenzumingcheng" label="分组名称"> </el-table-column>
					<el-table-column show-overflow-tooltip :render-header="renderHeader" prop="lurushijian" label="派车时间"> </el-table-column>
					<el-table-column show-overflow-tooltip :render-header="renderHeader" prop="lururen" label="派车人"> </el-table-column>
					<el-table-column show-overflow-tooltip :render-header="renderHeader" prop="paifangbiaozhun" label="排放标准"> </el-table-column>
					<el-table-column show-overflow-tooltip :render-header="renderHeader" prop="paifangleixing" label="排放类型"> </el-table-column>
					<el-table-column show-overflow-tooltip :render-header="renderHeader" prop="zhuangtai" label="审核状态(0待审核;1审核通过;2审核通过)">
					</el-table-column>
				</el-table>

				<!--根据车队编号获取车辆分组数据-->
				<div class="componentSty_content_title">
					<span class="fonints">车队名称</span>
					<el-input placeholder="请输入关键词" v-model="fz_fleetname" clearable>
					</el-input>
					<button class="buttons" @click="getCarGroupByFleet">查询车辆分组数据</button>
					<button class="buttons" @click="updateCarGroupByFleet"
						style="background-color: #f56c6c;">手动更新车辆分组数据</button>
					<span style="color: #606266;font-size: 14px;">
						【根据车队名称获取分组数据】
					</span>
				</div>
				<el-table :data="arrCarGroupList" border height="40%"
					style="width: 100%; height: 80%;border-bottom: 2px solid #17B6A1;">
					<el-table-column show-overflow-tooltip :render-header="renderHeader" label="序号" type="index" width="50px"></el-table-column>
					<el-table-column show-overflow-tooltip :render-header="renderHeader" prop="chepaihao" label="车牌号"> </el-table-column>
					<el-table-column show-overflow-tooltip :render-header="renderHeader" prop="cheduimingcheng" label="车队名称"> </el-table-column>
					<el-table-column show-overflow-tooltip :render-header="renderHeader" prop="fenzumingcheng" label="分组名称"> </el-table-column>
					<el-table-column show-overflow-tooltip :render-header="renderHeader" prop="lurushijian" label="录入时间"> </el-table-column>
					<el-table-column show-overflow-tooltip :render-header="renderHeader" prop="lururen" label="录入人"> </el-table-column>
					<el-table-column show-overflow-tooltip :render-header="renderHeader" prop="zhuangtai" label="审核状态(0待审核;1审核通过;2审核通过)">
					</el-table-column>
				</el-table>

			</div>


		</div>
	</div>
</template>
<script>
	import mTitle from "@/components/mTitle";
	import {
		antiShake
	} from "@/plugins/other.js";
	import {
		mapMutations,
		mapState
	} from "vuex";
	export default {
		data() {
			return {
				listitem: [{
					name: "运维管理"
				}, {
					name: "数据交换查询"
				}],
				conditions: {},
				jhgx_jihuadanhao: '',
				zt_jihuahao: '',
				zt_chepaihao: '',
				jhgx_arr: [],
				arrWeightList: [],
				timeout: null,
				arrlist: {},
				arrFleetList: [],
				arrCarList: [],
				arrCarGroupList: [],
				pc_jihuahao: '',
				fleetname: '',
				fz_fleetname: ''
			};
		},
		computed: {
			...mapState(["conditionsList"]),
		},
		components: {
			mTitle,
		},
		created() {
			this.conditionsList[this.$route.path] ||
				this.createConditions({
					key: this.$route.path,
					val: {
						page: 1,
						limit: 20,
						sidx: "fleet_status", //排序字段
						order: "asc"
					},
				});
			this.conditions = this.conditionsList[this.$route.path] || {
				page: 1,
				limit: 20,
				sidx: "fleet_status", //排序字段
				order: "asc"
			};
		},
		methods: {
			...mapMutations(["createConditions"]),
			async getCarListByFleet() {
				if (!this.fleetname) {
					return this.$message.error("请输入车队名称！");
				}
				const {
					data
				} = await this.$http(
					"api1",
					"/jtmt_sc/api/getCarListByFleet",
					"get", {
						"fleetName": this.fleetname
					}
				);
				if (!data)
					return this.$message.error("获取数据失败");


				this.arrCarList = data.data;
			},
			async getCarGroupByFleet() {
				if (!this.fz_fleetname) {
					return this.$message.error("请输入车队名称！");
				}
				const {
					data
				} = await this.$http(
					"api1",
					"/jtmt_sc/api/getCarGroupByFleet",
					"get", {
						"fleetName": this.fz_fleetname
					}
				);
				if (!data)
					return this.$message.error("获取数据失败");

				this.arrCarGroupList = data.data;
			},
			
			async updateCarGroupByFleet(){
				if (!this.fz_fleetname) {
					return this.$message.error("请输入车队名称！");
				}
				const {
					data
				} = await this.$http(
					"api1",
					"/jtmt_sc/api/updateCarGroupByFleet",
					"get", {
						"fleetName": this.fz_fleetname
					}
				);
				
				
				console.log('updateCarGroupByFleet....', data);
				
				if (!data) {
					return this.$message.error("获取数据失败");
				} else {
					this.$message.success("更新数据成功");
				}
				
			},
			
			async updateCarListByFleet(){
				if (!this.fleetname) {
					return this.$message.error("请输入车队名称！");
				}
				const {
					data
				} = await this.$http(
					"api1",
					"/jtmt_sc/api/updateCarListByFleet",
					"get", {
						"fleetName": this.fleetname
					}
				);
				
				console.log('updateCarListByFleet....', data);
				
				if (!data) {
					return this.$message.error("获取数据失败");
				} else {
					this.$message.success("更新数据成功");
				}
				
			},
			async getjhgxarrlist() {
				if (!this.jhgx_jihuadanhao) {
					return this.$message.error("请输入计划号！");
				}
				this.jhgx_arr = [];
				const {
					data
				} = await this.$http(
					"api1",
					"/jtmt_sc/api/getPlanInfoByPno",
					"get", {
						"planNo": this.jhgx_jihuadanhao
					}
				);
				if (!data)
					return this.$message.error("获取数据失败");
				console.log('data....', data);
				this.jhgx_arr.push(data.data);
			},
			async getCarLastState() {
				if (!this.zt_chepaihao) {
					return this.$message.error("请输入车牌号！");
				}
				const {
					data
				} = await this.$http(
					"api1",
					"/jtmt_sc/api/getCarLastState",
					"get", {
						"planNo": this.zt_jihuahao,
						"plateNo": this.zt_chepaihao
					}
				);
				if (!data || !data.data) {
					return this.$message.error("没有获取到车牌号-" + this.zt_chepaihao + "的作业状态！");
				} else {
					this.$message.success("车牌号-" + this.zt_chepaihao + "的状态为:" + data.data[0]["state"]);
				}


			},
			async getWeightList() {
				if (!this.zt_jihuahao) {
					return this.$message.error("请输入计划号！");
				}
				const {
					data
				} = await this.$http(
					"api1",
					"/jtmt_sc/api/getWeightListByParams",
					"get", {
						"planNo": this.zt_jihuahao
					}
				);
				if (!data)
					return this.$message.error("获取数据失败");


				this.arrWeightList = data.data;
			},
			async getFleetDispatch() {
				if (!this.pc_jihuahao) {
					return this.$message.error("请输入计划号！");
				}
				const {
					data
				} = await this.$http(
					"api1",
					"/jtmt_sc/api/getFleetDispatch",
					"get", {
						"planNo": this.pc_jihuahao
					}
				);
				if (!data)
					return this.$message.error("获取数据失败");


				this.arrFleetList = data.data;
			},
			async updateFleetDispatch() {
				if (!this.pc_jihuahao) {
					return this.$message.error("请输入计划号！");
				}
				const {
					data
				} = await this.$http(
					"api1",
					"/jtmt_sc/api/updateFleetDispatch",
					"get", {
						"planNo": this.pc_jihuahao
					}
				);
				
				console.log('updateFleetDispatch.....',data);
				
				if (!data) {
					return this.$message.error("获取数据失败");
				} else {
					this.$message.success("更新计划成功");
				}
			},

			async updatePlanInfoByPno() {
				if (!this.jhgx_jihuadanhao) {
					return this.$message.error("请输入计划号！");
				}
				const {
					data
				} = await this.$http(
					"api1",
					"/jtmt_sc/api/updatePlanInfoByPno",
					"get", {
						"planNo": this.jhgx_jihuadanhao
					}
				);
				if (!data) {
					return this.$message.error("获取数据失败");
				} else {
					this.$message.success("更新计划成功");
				}

			},
			async getLastWeightByPlateNumber() {
				if (!this.zt_chepaihao) {
					return this.$message.error("请输入车牌号！");
				}
				const {
					data
				} = await this.$http(
					"api1",
					"/jtmt_sc/api/getWeightListByParams",
					"get", {
						"plateNo": this.zt_chepaihao
					}
				);
				if (!data)
					return this.$message.error("获取数据失败");
				this.arrWeightList = data.data;
			},
			async updateBangDan() {
				if (!this.zt_jihuahao) {
					return this.$message.error("请输入计划号！");
				}
				const {
					data
				} = await this.$http(
					"api1",
					"/jtmt_sc/api/updateBangDan",
					"get", {
						"plateNo": this.zt_chepaihao,
						"planNo":this.zt_jihuahao
					}
				);
				if (!data) {
					return this.$message.error("更新磅单失败！");
				} else {
					this.$message.success("更新磅单成功");
				}
			},
			itemparticulars(res) {
				window.sessionStorage.setItem("infoid", res.id);
				this.$router.push({
					name: "particulars"
				});
			},
			async checkState(row) {
				if (row.fleetStatus == 3) {
					row.fleetStatus = 1;
					const {
						data
					} = await this.$http(
						"api1",
						"/fleet/fleetfleetmessage/fleetInitiateMode",
						"post", {
							"ids": [row.id]
						}
					);
					if (!data || data.msg != "success") return this.$message.error("修改失败");
					this.$message.success("启用成功");
				} else {
					row.fleetStatus = 3;
					const {
						data
					} = await this.$http(
						"api1",
						"/fleet/fleetfleetmessage/fleetDeadStatus",
						"post", {
							"ids": [row.id]
						}
					);
					if (!data || data.msg != "success") return this.$message.error("修改失败");
					this.$message.success("停用成功");
				}
			},
			selectlist() {
				antiShake(_ => {
					this.conditions.page = 1;
					this.getarrlist();
				})
			},
		},
	};
</script>
<style lang="scss" src="@/assets/components.scss" scoped></style>